import { useCallback, useMemo, useState } from 'react';

interface IUseCommentsFooterValidationParams {
    comment: string;
    attachedFilesCount: number;
    onCommentChange: (value: string) => void;
    onSave: () => void;
}

export const useCommentsFooterValidation = ({
    comment,
    attachedFilesCount,
    onCommentChange,
    onSave,
}: IUseCommentsFooterValidationParams) => {
    const [hasValidationError, setHasValidationError] = useState(false);
    const normalizedComment = useMemo(() => comment.trim(), [comment]);

    const handleCommentInputChange = useCallback(
        (value: string) => {
            onCommentChange(value);
            setHasValidationError(false);
        },
        [onCommentChange]
    );

    const clearValidationError = useCallback(() => {
        setHasValidationError(false);
    }, []);

    const handleCommentSave = useCallback(() => {
        if (!normalizedComment && attachedFilesCount === 0) {
            setHasValidationError(true);
            return;
        }

        setHasValidationError(false);
        onSave();
    }, [attachedFilesCount, normalizedComment, onSave]);

    return {
        hasValidationError,
        handleCommentInputChange,
        clearValidationError,
        handleCommentSave,
    };
};
